import { Decorative } from "@faire/design-tokens";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";

import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";

export const NewBrandsFreeShippingBanner: React.FC = () => {
  const { layoutElement } = React.useContext(Context);
  const {
    images,
    main_text,
    main_text_color,
    tagline_text,
    tagline_text_color,
    description_text_color,
    description_text,
  } = layoutElement;
  const isSSR = useIsSSR();
  return (
    <Wrapper>
      {images[0] ? (
        <BannerImage
          $backgroundUrl={optimizeImageUrl(images[0], isSSR, {
            width: 600,
          })}
        />
      ) : null}
      <Content>
        <Typography variant="labelSansMedium" color={main_text_color}>
          {main_text}
        </Typography>
        <Typography
          variant="pageHeaderSerifRegular"
          color={description_text_color}
        >
          {description_text}
        </Typography>
        {tagline_text ? (
          <>
            <Spacer height={{ mobileAndAbove: "2x", tabletAndAbove: "1x" }} />
            <Typography
              variant="paragraphSansRegular"
              color={tagline_text_color}
            >
              {tagline_text}
            </Typography>
          </>
        ) : null}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
})`
  margin-bottom: ${getSpacing("3x")};
  background-color: ${Decorative.tint.orange};
  ${responsiveMediaQueries.tabletAndAbove} {
    height: 140px;
  }
`;

const Content = styled(Column)`
  width: 100%;
  height: 100%;
  padding: ${getSpacing("3x", "4x")};
`;

const BannerImage = styled.div<{ $backgroundUrl?: string }>`
  width: 100%;
  background-image: url(${(props) => props.$backgroundUrl});
  background-size: cover;
  background-position: center;
  ${responsiveMediaQueries.tabletAndAbove} {
    width: 30%;
    height: auto;
  }
`;
